const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const Facebook = () => import(/* webpackChunkName: "facebook" */ './view/edit.vue');

export const ROUTE_NAME_FACEBOOK = 'Facebook';

export default [
    {
        path: '/app/:appId/facebook',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_FACEBOOK,
                component: Facebook,
                meta: { requiresAuth: true }
            }
        ]
    }
];
